<script>
export default {
    name: 'oc-new-line',
    functional: true,
    render: function (h, context) {
        return h('br')
    }
}
</script>
